import React, { SyntheticEvent } from 'react';
import { Col, Row } from '@flightstats/airframe-react';
import styled from 'styled-components';

import { emptyFieldCharacter } from './EditTripGroupContainer';
import { StyledSwitch } from '../../components/forms/Switch';
import {
  Input,
  FormLabeledInputRowWrapper,
  FormWrapper,
} from '../../components/forms/Input';

const Header = styled.h4`
  margin-bottom: 0;
`;

interface TripGroupInfoSectionProps {
  lineage?: string;
  groupName?: string;
  setGroupName: (value: string) => void;
  isHidden: boolean;
  setIsHidden: (value: boolean) => void;
  isDefault: boolean;
}

export const TripGroupInfoSection: React.FC<TripGroupInfoSectionProps> = ({
  lineage = emptyFieldCharacter,
  groupName = emptyFieldCharacter,
  setGroupName,
  isHidden,
  setIsHidden,
  isDefault,
}) => {
  const groupNameOnChangeHandler = (
    event: SyntheticEvent<HTMLInputElement>,
  ) => {
    if (event?.target instanceof window.HTMLInputElement) {
      setGroupName(event?.target?.value);
    }
  };

  let displayLineage = lineage?.split(' | ');

  if (displayLineage?.[0].startsWith('ACCOUNT_ID:')) {
    displayLineage = displayLineage.slice(1);
  }

  return (
    <>
      <Row>
        <Col>
          <Header>Information</Header>
        </Col>
        {!isDefault && (
          <Col align={'flex-end'}>
            <StyledSwitch
              text="Hide Trip Group"
              name="hideTripGroup"
              on={isHidden}
              onChange={setIsHidden}
              textRight={false}
            />
          </Col>
        )}
      </Row>
      {!isDefault && (
        <Col align={'flex-end'} style={{ paddingRight: 0 }}>
          <small>
            Hide this group from search results and disable all alerting for
            current and future trips in this group
          </small>
        </Col>
      )}
      <FormWrapper>
        <FormLabeledInputRowWrapper
          elementId="lineage"
          label="Lineage:"
          inputWidth="100%"
        >
          <span className="fs-exclude" data-fs-exclude>
            {(!displayLineage?.length && <strong>Account Default</strong>) ||
              displayLineage?.map(item => <div key={item}>{item}</div>) ||
              emptyFieldCharacter}
          </span>
        </FormLabeledInputRowWrapper>
        <FormLabeledInputRowWrapper
          elementId={`${groupName || emptyFieldCharacter}Input`}
          label="Group Name:"
          inputWidth='18rem'
        >
          <span className="fs-exclude" data-fs-exclude>
            <Input
              name={`${groupName || emptyFieldCharacter}Input`}
              value={groupName}
              onChange={groupNameOnChangeHandler}
            />
          </span>
        </FormLabeledInputRowWrapper>
      </FormWrapper>
    </>
  );
};
